import React from "react";

function Icon(data) {
  return (
    <svg width={data.w} height={data.h} xmlns="http://www.w3.org/2000/svg">
       <g fill="#FFF" fillRule="nonzero">
         <path d="M27.9 21.636c-.8 0-1.5.7-1.5 1.5v16.4l-4.4-4.4c-.6-.6-1.6-.6-2.1 0-.6.6-.6 1.6 0 2.1l7 7c.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4l7-7c.6-.6.6-1.6 0-2.1-.6-.6-1.6-.6-2.1 0l-4.4 4.4v-16.3c-.2-.9-.9-1.6-1.7-1.6Z" />
         <path d="M54.1 20.836c-.8 0-1.5.7-1.5 1.5v50.6c0 1.7-1.4 3.1-3.1 3.1H6.1c-1.7 0-3.1-1.4-3.1-3.1v-66.8c0-1.7 1.4-3.1 3.1-3.1h31.6v9.3c0 3 2.5 5.5 5.5 5.5H54c.6 0 1.2-.4 1.4-.9.2-.5.1-1.2-.3-1.7L40.3.436c-.4-.4-.9-.5-1.3-.4H6.2c-3.4 0-6.2 2.8-6.2 6.2v66.8c0 3.4 2.8 6.2 6.2 6.2h43.3c3.4 0 6.2-2.8 6.2-6.2v-50.7c-.1-.8-.7-1.5-1.6-1.5Zm-10.9-6.1c-1.4 0-2.5-1.1-2.5-2.5v-7.2l9.7 9.7h-7.2Z" />
         <path d="M38.6 50.736c0-.8-.7-1.5-1.5-1.5H18.7c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h18.4c.8 0 1.5-.6 1.5-1.5Z" />
       </g>
    </svg>
  );
}

export default Icon;
